import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

interface RenderParticipantNameProps {
  participantId: number;
  name: string;
  profilePicture?: string | null;
  noBorder?: boolean;
}

const generateColorFromIdAndName = (participantId: number, name: string) => {
  let hash = participantId;
  const combinedName = `${participantId}-${name}`; // Combine participantId and name

  for (let i = 0; i < combinedName.length; i++) {
    hash = combinedName.charCodeAt(i) + ((hash << 5) - hash);
  }

  const color = `hsl(${hash % 360}, 70%, 80%)`; // Creates a soft color based on the hash
  return color;
};


const getInitials = (name: string) => {
  const nameParts = name.trim().split(' ');
  return nameParts.length > 1
    ? nameParts[0][0].toUpperCase() + nameParts[1][0].toUpperCase()
    : nameParts[0][0].toUpperCase();
};

export const RenderParticipantName = (
  participantId: number,
  name: string,
  profilePicture: string | null = null,
  noBorder: boolean = false
) => {
  return (
    <Box
      component="td"
      sx={{
        borderBottom: noBorder ? 'none' : '1px solid rgba(224, 224, 224, 1)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Link
        to={`/participant/${participantId}`}
        style={{
          textDecoration: 'none',
          color: '#1976d2',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          transition: 'color 0.3s',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = '#0d47a1')}
        onMouseLeave={(e) => (e.currentTarget.style.color = '#1976d2')}
      >
        {profilePicture ? (
          <img
            src={`https://photoskiff.com/zaruba/dbapi/uploads/${profilePicture}`}
            alt={name}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              marginRight: '10px',
            }}
          />
        ) : (
          <Box
            sx={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: generateColorFromIdAndName(participantId, name),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.2rem',
              color: '#ffffff',
              fontWeight: 'bold',
              marginRight: '10px',
            }}
          >
            {getInitials(name)}
          </Box>
        )}
        {name}
      </Link>
    </Box>
  );
};

export const RenderParticipantPicture = (
  participantId: number,
  name: string,
  profilePicture: string | null = null,
  size: number = 40
) => {
  return (
    <Box
      component="td"
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Link
        to={`/participant/${participantId}`}
        style={{
          textDecoration: 'none',
          color: '#1976d2',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          transition: 'color 0.3s',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = '#0d47a1')}
        onMouseLeave={(e) => (e.currentTarget.style.color = '#1976d2')}
      >
        {profilePicture ? (
          <img
            src={`https://photoskiff.com/zaruba/dbapi/uploads/${profilePicture}`}
            alt={name}
            style={{
              width: size,
              height: size,
              borderRadius: '50%',
              marginRight: '10px',
            }}
          />
        ) : (
          <Box
            sx={{
              width: size,
              height: size,
              borderRadius: '50%',
              backgroundColor: generateColorFromIdAndName(participantId, name),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.2rem',
              color: '#ffffff',
              fontWeight: 'bold',
              marginRight: '10px',
            }}
          >
            {getInitials(name)}
          </Box>
        )}
      </Link>
    </Box>
  );
};
